import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export enum RecentWritingTab {
  EWI = 'ewi',
  LessonActivity = 'lesson',
  PlacementTest = 'placement',
  LongWrites = 'longWrites',
}

export default class WritingLegendsRecentWritingController extends Controller {
  queryParams = ['tab', 'pageNumber', 'perPage']

  @tracked tab = RecentWritingTab.EWI

  @tracked pageNumber = 1

  @tracked perPage = 10
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/writing-legends/recent-writing': WritingLegendsRecentWritingController
  }
}
